{
  "familyId": "MET-HOEK-SOORTEN",
  "questions": [
    {
      "id": "MET-HOEK-SOORTEN-001",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een timmerman zaagt een plank schuin af. De zaaghoek is 55°. Wat voor soort hoek is dat?",
      "context": null,
      "options": ["een scherpe hoek", "een rechte hoek", "een stompe hoek", "een gestrekte hoek"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 55,
            "showValue": false,
            "label": "Welk soort hoek is dit?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 55,
            "showValue": true,
            "angleType": "scherp",
            "label": "55° is een scherpe hoek"
          }
        }
      ],
      "conceptId": "hoek_soorten_scherp",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 55° is scherp, niet stomp of recht", "optionIndex": 2 },
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 55° is scherp, niet recht", "optionIndex": 1 }
        ]
      },
      "feedback": {
        "explanationText": "55° is kleiner dan 90°, dus het is een scherpe hoek. Scherpe hoeken zijn 'spits' — ze zijn kleiner dan een rechte hoek. Controleer: 55° < 90° → scherp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 55°",
          "Vergelijk met 90°: 55° < 90°",
          "Kleiner dan 90° = scherpe hoek",
          "Check: een scherpe hoek is spits, dat past bij 55° ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 55° is kleiner dan 90°, dus het is een scherpe hoek.",
          "1": "Je dacht waarschijnlijk dat 55° een rechte hoek is. Maar een rechte hoek is precies 90°, en 55° is kleiner dan 90°. Onthoud: alleen exact 90° is recht.",
          "2": "Je dacht waarschijnlijk dat 55° een stompe hoek is. Maar een stompe hoek is groter dan 90°. 55° is juist kleiner dan 90°, dus scherp. Onthoud: stomp = wijd = groter dan 90°.",
          "3": "Je dacht waarschijnlijk dat 55° een gestrekte hoek is. Maar een gestrekte hoek is precies 180°. 55° is veel kleiner. Onthoud: gestrekt = 180° = een rechte lijn."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-002",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een dakdekker meet de hoek van een schuin dak. De hoek is 135°. Wat voor soort hoek is dat?",
      "context": null,
      "options": ["een scherpe hoek", "een rechte hoek", "een stompe hoek", "een gestrekte hoek"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 135,
            "showValue": false,
            "label": "Welk soort hoek is dit?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 135,
            "showValue": true,
            "angleType": "stomp",
            "label": "135° is een stompe hoek"
          }
        }
      ],
      "conceptId": "hoek_soorten_stomp",
      "variantIndex": 2,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 135° is stomp, niet scherp", "optionIndex": 0 },
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 135° is stomp, niet gestrekt", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "135° is groter dan 90° maar kleiner dan 180°, dus het is een stompe hoek. Onthoud: stomp = 'wijd' — de hoek is wijder dan een rechte hoek maar nog geen rechte lijn. Controleer: 90° < 135° < 180° → stomp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 135°",
          "Vergelijk: 135° > 90° → niet scherp en niet recht",
          "Vergelijk: 135° < 180° → niet gestrekt",
          "Check: tussen 90° en 180° = stompe hoek ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 135° een scherpe hoek is. Maar een scherpe hoek is kleiner dan 90°, en 135° is groter dan 90°. Onthoud: scherp = spits = kleiner dan 90°.",
          "1": "Je dacht waarschijnlijk dat 135° een rechte hoek is. Maar een rechte hoek is precies 90°, en 135° is groter. Onthoud: alleen exact 90° is recht.",
          "2": "Goed! 135° ligt tussen 90° en 180°, dus het is een stompe hoek.",
          "3": "Je dacht waarschijnlijk dat 135° een gestrekte hoek is. Maar een gestrekte hoek is precies 180°, en 135° is kleiner. Onthoud: gestrekt = 180° = een rechte lijn."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-003",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een draaischijf in een fabriek draait een kwart slag. Hoeveel graden is dat? En wat voor soort hoek ontstaat er?",
      "context": null,
      "options": ["180° — een gestrekte hoek", "90° — een rechte hoek", "360° — een volle draai", "45° — een scherpe hoek"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 90,
            "showValue": true,
            "angleType": "recht",
            "label": "Kwart draai = 90° = rechte hoek"
          }
        }
      ],
      "conceptId": "hoek_draai_kwart",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-rotation-confused", "label": "Draaihoek verward: kwart draai = 90°, niet 180°", "optionIndex": 0 },
          { "id": "met.angle-rotation-confused", "label": "Draaihoek verward: kwart draai = 90°, niet 360°", "optionIndex": 2 },
          { "id": "met.angle-rotation-confused", "label": "Draaihoek verward: kwart draai = 90°, niet 45°", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "Een volle draai is 360°. Een kwart daarvan is 360° ÷ 4 = 90°. Een hoek van 90° is een rechte hoek. Onthoud: van 12 naar 3 op de klok is een kwart draai = 90°. Controleer: kwart van 360° = 90° ✓.",
        "solutionSteps": [
          "Een volle draai = 360°",
          "Een kwart slag = 360° ÷ 4 = 90°",
          "90° = rechte hoek",
          "Check: van 12 naar 3 op de klok = kwart draai = 90° ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat een kwart draai 180° is. Maar 180° is een halve draai (gestrekte hoek). Een kwart draai = 360° ÷ 4 = 90°. Onthoud: kwart = 90°, half = 180°.",
          "1": "Goed! Een kwart draai = 360° ÷ 4 = 90°, en dat is een rechte hoek.",
          "2": "Je dacht waarschijnlijk dat een kwart draai 360° is. Maar 360° is een volle draai. Een kwart daarvan = 360° ÷ 4 = 90°. Onthoud: 360° = heel, 90° = kwart.",
          "3": "Je dacht waarschijnlijk dat een kwart draai 45° is. Maar 45° is een achtste draai (360° ÷ 8). Een kwart draai = 360° ÷ 4 = 90°. Onthoud: kwart = 90°."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-004",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een interieurontwerper bekijkt de hoeken van een kamer. De kamer heeft de vorm van een rechthoek. Wat weet je zeker over de hoeken?",
      "context": null,
      "options": ["Twee hoeken zijn scherp en twee zijn stomp", "Alle hoeken zijn stomp", "De hoeken zijn allemaal verschillend", "Alle 4 hoeken zijn 90° (rechte hoeken)"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 90,
            "showValue": true,
            "angleType": "recht",
            "label": "Rechthoek: alle hoeken zijn 90°"
          }
        }
      ],
      "conceptId": "hoek_rechthoek",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: rechthoek heeft 4 rechte hoeken, niet 2 scherp + 2 stomp", "optionIndex": 0 },
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 90° is recht, niet stomp", "optionIndex": 1 }
        ]
      },
      "feedback": {
        "explanationText": "In een rechthoek zijn alle vier de hoeken rechte hoeken van 90°. Dat is precies waarom het een RECHThoek heet — alle hoeken zijn recht. Samen: 4 × 90° = 360°. Onthoud: de naam 'rechthoek' vertelt je al dat de hoeken recht zijn.",
        "solutionSteps": [
          "Een rechthoek heeft 4 hoeken",
          "Alle 4 hoeken zijn 90° (recht)",
          "Totaal: 4 × 90° = 360° (volle draai)",
          "Check: de naam 'RECHThoek' verwijst naar de rechte hoeken ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk aan een parallellogram of ruit. Daar zijn inderdaad twee hoeken scherp en twee stomp. Maar een rechthoek heeft vier gelijke rechte hoeken van 90°. Onthoud: RECHThoek = RECHTE hoeken.",
          "1": "Je dacht waarschijnlijk dat alle hoeken stomp zijn. Maar stompe hoeken zijn groter dan 90°, en in een rechthoek zijn alle hoeken precies 90°. Onthoud: 90° = recht, niet stomp.",
          "2": "Je dacht waarschijnlijk dat de hoeken verschillend zijn. Maar in een rechthoek zijn alle vier de hoeken gelijk: 90°. Onthoud: bij een rechthoek zijn alle hoeken hetzelfde.",
          "3": "Goed! Alle hoeken in een rechthoek zijn 90° (rechte hoeken)."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-005",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Een verkeerskundige bekijkt een kruispunt. Twee wegen vormen een hoek van precies 180°. Wat voor soort hoek is dat?",
      "context": null,
      "options": ["een stompe hoek", "een rechte hoek", "een gestrekte hoek", "een volle draai"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 180,
            "showValue": false,
            "label": "Welk soort hoek is dit?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 180,
            "showValue": true,
            "angleType": "gestrekt",
            "label": "180° is een gestrekte hoek"
          }
        }
      ],
      "conceptId": "hoek_soorten_gestrekt",
      "variantIndex": 5,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.75,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 180° is gestrekt, niet stomp", "optionIndex": 0 },
          { "id": "met.angle-rotation-confused", "label": "Draaihoek verward: 180° is halve draai, niet volle draai", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "180° is een gestrekte hoek. De twee wegen vormen samen een rechte lijn. 'Gestrekt' betekent 'uitgerekt tot een lijn'. Een halve draai (180°) is precies een gestrekte hoek. Controleer: 180° = halve draai = gestrekte hoek ✓.",
        "solutionSteps": [
          "Bekijk het getal: 180°",
          "180° = precies een halve draai",
          "Een halve draai = gestrekte hoek (rechte lijn)",
          "Check: de twee wegen vormen een rechte lijn ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat 180° een stompe hoek is. Een stompe hoek is groter dan 90° maar kleiner dan 180°. Precies 180° is gestrekt, niet stomp. Onthoud: stomp = tussen 90° en 180°, gestrekt = precies 180°.",
          "1": "Je dacht waarschijnlijk dat 180° een rechte hoek is. Maar een rechte hoek is 90°, niet 180°. 180° is het dubbele van een rechte hoek. Onthoud: recht = 90°, gestrekt = 180°.",
          "2": "Goed! 180° is een gestrekte hoek — de twee lijnen vormen een rechte lijn.",
          "3": "Je dacht waarschijnlijk dat 180° een volle draai is. Maar een volle draai is 360°. 180° is een halve draai = gestrekte hoek. Onthoud: vol = 360°, half = 180°."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-006",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "fill_in",
      "question": "Een hoek van 110° is een ... hoek. Typ het soort (scherp, recht, stomp of gestrekt).",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["stomp", "stompe"],
        "caseSensitive": false,
        "placeholder": "... hoek"
      },
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 110,
            "showValue": false,
            "label": "Welk soort hoek is dit?"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 110,
            "showValue": true,
            "angleType": "stomp",
            "label": "110° is een stompe hoek"
          }
        }
      ],
      "conceptId": "hoek_soorten_stomp_fill",
      "variantIndex": 6,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.71,
      "pedagogy": {
        "dok": 2
      },
      "feedback": {
        "explanationText": "110° is groter dan 90° maar kleiner dan 180°, dus het is een stompe hoek. Stompe hoeken zijn 'wijd' — groter dan een rechte hoek maar nog geen rechte lijn. Controleer: 90° < 110° < 180° → stomp ✓.",
        "solutionSteps": [
          "Bekijk het getal: 110°",
          "110° > 90° → niet scherp en niet recht",
          "110° < 180° → niet gestrekt",
          "Check: tussen 90° en 180° = stompe hoek ✓"
        ]
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-007",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Bekijk de hoek op de gradenboog. De hoek is 55°. Welk soort hoek is dit?",
      "context": null,
      "options": ["Scherpe hoek", "Rechte hoek", "Stompe hoek", "Gestrekte hoek"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 55,
            "showValue": false,
            "label": "Hoek meten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 55,
            "showValue": true,
            "angleType": "scherp",
            "label": "Dit is een scherpe hoek (55°)"
          }
        }
      ],
      "conceptId": "hoek_soorten_scherp_protractor",
      "variantIndex": 7,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 55° is scherp, niet recht", "optionIndex": 1 },
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 55° is scherp, niet stomp", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "55° is kleiner dan 90°, dus het is een scherpe hoek. Scherpe hoeken zijn 'spits' — kleiner dan een rechte hoek. Controleer: 0° < 55° < 90° → scherp ✓.",
        "solutionSteps": [
          "Lees de hoek af op de gradenboog: 55°",
          "55° < 90° → kleiner dan een rechte hoek",
          "Check: kleiner dan 90° = scherpe hoek ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 55° is een scherpe hoek: kleiner dan 90°.",
          "1": "Je dacht waarschijnlijk dat dit een rechte hoek is. Een rechte hoek is precies 90°. Deze hoek is 55°, dus kleiner dan 90° → scherp.",
          "2": "Je dacht waarschijnlijk dat dit een stompe hoek is. Een stompe hoek is groter dan 90° maar kleiner dan 180°. Deze hoek is 55°, dus kleiner dan 90° → scherp.",
          "3": "Je dacht waarschijnlijk dat dit een gestrekte hoek is. Een gestrekte hoek is precies 180°. Deze hoek is 55°, veel kleiner → scherp."
        }
      }
    },
    {
      "id": "MET-HOEK-SOORTEN-008",
      "familyId": "MET-HOEK-SOORTEN",
      "module": "Metriek",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "hoeken",
      "subSkill": "hoek_soorten",
      "questionType": "multiple_choice",
      "question": "Bekijk de hoek op de gradenboog. De hoek is 135°. Welk soort hoek is dit?",
      "context": null,
      "options": ["Stompe hoek", "Scherpe hoek", "Rechte hoek", "Gestrekte hoek"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "protractor",
          "showWhen": "always",
          "data": {
            "angle": 135,
            "showValue": false,
            "label": "Hoek meten"
          }
        }
      ],
      "supportAids": [
        {
          "type": "protractor",
          "showWhen": "wrong",
          "data": {
            "angle": 135,
            "showValue": true,
            "angleType": "stomp",
            "label": "Dit is een stompe hoek (135°)"
          }
        }
      ],
      "conceptId": "hoek_soorten_stomp_protractor",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 135° is stomp, niet scherp", "optionIndex": 1 },
          { "id": "met.angle-type-confused", "label": "Hoeksoort verward: 135° is stomp, niet recht", "optionIndex": 2 }
        ]
      },
      "feedback": {
        "explanationText": "135° is groter dan 90° maar kleiner dan 180°, dus het is een stompe hoek. Stompe hoeken zijn 'wijd' — groter dan een rechte hoek maar nog geen rechte lijn. Controleer: 90° < 135° < 180° → stomp ✓.",
        "solutionSteps": [
          "Lees de hoek af op de gradenboog: 135°",
          "135° > 90° → groter dan een rechte hoek",
          "135° < 180° → kleiner dan een gestrekte hoek",
          "Check: stompe hoek ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 135° is een stompe hoek: groter dan 90° en kleiner dan 180°.",
          "1": "Je dacht waarschijnlijk dat dit een scherpe hoek is. Een scherpe hoek is kleiner dan 90°. Deze hoek is 135°, dus groter dan 90° → stomp.",
          "2": "Je dacht waarschijnlijk dat dit een rechte hoek is. Een rechte hoek is precies 90°. Deze hoek is 135°, dus groter → stomp.",
          "3": "Je dacht waarschijnlijk dat dit een gestrekte hoek is. Een gestrekte hoek is precies 180°. Deze hoek is 135°, dus kleiner → stomp."
        }
      }
    }
  ]
}